module.exports = __webpack_public_path__ + "img/Eventos_notificacion_aprobado.1a508147.svg";